import React, { Component } from 'react'
import { hashHistory } from 'react-router'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'

import AppBar from 'material-ui/AppBar'

import { logout } from './../../actions'

import FlatButton from 'material-ui/FlatButton'

import IconButton from 'material-ui/IconButton'
import BackIcon from 'material-ui/svg-icons/navigation/chevron-left'

import Config from '../../config/AppConfig'

class AppIndex extends Component {
  static propTypes = {
    isLoggedIn: PropTypes.bool.isRequired,
    children: PropTypes.any.isRequired,
    actions: PropTypes.object.isRequired
  }

  render() {
    return (
      <div>
        <AppBar
          title={
            this.props.title === null ? Config.appName : this.props.title.label
          }
          iconElementLeft={
            this.props.title.back === false
              ? null
              : <IconButton>
                  <BackIcon />
                </IconButton>
          }
          titleStyle={{ cursor: 'pointer' }}
          onTitleTouchTap={() => {
            this.props.title.action()
          }}
          onLeftIconButtonTouchTap={() => {
            this.props.title.action()
          }}
          showMenuIconButton={this.props.title.back}
          iconElementRight={
            this.props.isLoggedIn
              ? <FlatButton
                  label="Cerrar sesión"
                  onTouchTap={() => {
                    this.props.actions.logout({}, () => {
                      hashHistory.push('/login')
                    })
                  }}
                />
              : this.props.location.pathname !== '/login'
                ? <FlatButton
                    label="Iniciar sesión"
                    onTouchTap={() => {
                      hashHistory.push('profile')
                    }}
                  />
                : null
          }
        />
        {this.props.children}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    isLoggedIn: state.isLoggedIn,
    title: state.title
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ logout }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppIndex)



// WEBPACK FOOTER //
// ./src/components/App/AppIndex.js